"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6601],{

/***/ 84502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ seoDescriptionDeal; }
});

// EXTERNAL MODULE: ./utilities/budgetFormatter.ts
var budgetFormatter = __webpack_require__(40822);
;// CONCATENATED MODULE: ./utilities/removeExtraSpaces.ts
var removeExtraSpaces = function(text) {
    return text.replace(/\s\s+/g, " ");
};

;// CONCATENATED MODULE: ./components/head/seoDescriptionDeal.ts


function seoDescriptionDeal(param) {
    var companyName = param.companyName, collectionName = param.collectionName, currency = param.currency, minBudget = param.minBudget, maxBudget = param.maxBudget, royaltyPercentage = param.royaltyPercentage, requestedNumberOfNfts = param.requestedNumberOfNfts, numberOfCollections = param.numberOfCollections;
    var budgetPart = "";
    var royaltyPart = "";
    if (minBudget && maxBudget) {
        budgetPart = (0,budgetFormatter/* budgetFormatter */.n)(minBudget, maxBudget, currency);
    }
    if (royaltyPercentage) {
        royaltyPart = "".concat(royaltyPercentage, "%");
    }
    var budgetRoyaltyString = "";
    if (budgetPart && royaltyPart) {
        budgetRoyaltyString = "".concat(budgetPart.trim(), " and ").concat(royaltyPart);
    } else if (budgetPart) {
        budgetRoyaltyString = budgetPart;
    } else if (royaltyPart) {
        budgetRoyaltyString = royaltyPart;
    }
    var collectionString = "";
    if (numberOfCollections > 1) {
        var suffix = numberOfCollections === 2 ? "collection" : "collections";
        collectionString = "and ".concat(numberOfCollections - 1, " other ").concat(suffix);
    }
    var descriptionParts = [
        companyName,
        "is looking to license ".concat(requestedNumberOfNfts),
        "".concat(requestedNumberOfNfts === 1 ? "NFT" : "NFTs"),
        "on @OverpassIP from ".concat(collectionName),
        collectionString, 
    ];
    if (budgetRoyaltyString) {
        descriptionParts.push("for a budget of ".concat(budgetRoyaltyString, " per NFT"));
    }
    return removeExtraSpaces(descriptionParts.join(" ")) + ".";
}


/***/ }),

/***/ 56245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kJ": function() { return /* binding */ ArrowButtonStyle; },
  "n4": function() { return /* binding */ ArrowDirection; },
  "ZP": function() { return /* binding */ navigation_ArrowButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/svg/LeftNavArrow.tsx


var LeftNavArrow = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8490FF" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1344_798)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19 12L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11 6L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11 18L5 12",
                        stroke: fill,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1344_798",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(24 24) rotate(-180)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var svg_LeftNavArrow = (LeftNavArrow);

;// CONCATENATED MODULE: ./components/navigation/ArrowButton.tsx



var ArrowDirection;
(function(ArrowDirection) {
    ArrowDirection["left"] = "rotate-0";
    ArrowDirection["right"] = "rotate-180";
    ArrowDirection["up"] = "rotate-90";
    ArrowDirection["down"] = "-rotate-90";
})(ArrowDirection || (ArrowDirection = {}));
var ArrowButtonStyle;
(function(ArrowButtonStyle) {
    ArrowButtonStyle["default"] = "flex rounded-full w-10 h-10 bg-white active:bg-primary-pressed";
    ArrowButtonStyle["dark"] = "flex rounded-full w-10 h-10 font-white bg-primary-main active:bg-primary-pressed";
    ArrowButtonStyle["border"] = "flex rounded-full w-10 h-10 border-primary-main border-[1px] bg-white";
})(ArrowButtonStyle || (ArrowButtonStyle = {}));
var ArrowButton = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var _direction = param.direction, direction = _direction === void 0 ? ArrowDirection.left : _direction, classes = param.classes, _style = param.style, style = _style === void 0 ? ArrowButtonStyle.default : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        ref: ref,
        className: "".concat(style, " flex-shrink-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full place-content-center items-center self-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: direction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_LeftNavArrow, {
                    classes: classes,
                    fill: style === ArrowButtonStyle.dark ? "#fff" : "#8490FF"
                })
            })
        })
    });
});
ArrowButton.displayName = "ArrowButton";
/* harmony default export */ var navigation_ArrowButton = (ArrowButton);


/***/ }),

/***/ 72235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ DealComponent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/moment-timezone/builds/moment-timezone-with-data-2012-2022.js
var moment_timezone_with_data_2012_2022 = __webpack_require__(33353);
var moment_timezone_with_data_2012_2022_default = /*#__PURE__*/__webpack_require__.n(moment_timezone_with_data_2012_2022);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next-auth/react/index.js
var react = __webpack_require__(23848);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var node_modules_react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(77245);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(43997);
// EXTERNAL MODULE: ../../node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69702);
// EXTERNAL MODULE: ./components/UI/Divider.tsx
var Divider = __webpack_require__(57803);
// EXTERNAL MODULE: ./components/UI/Pill.tsx
var Pill = __webpack_require__(50850);
// EXTERNAL MODULE: ./components/UI/buttons/Button.tsx + 3 modules
var Button = __webpack_require__(21489);
// EXTERNAL MODULE: ./components/UI/toast/Toast.tsx + 1 modules
var Toast = __webpack_require__(96125);
// EXTERNAL MODULE: ./components/cards/Avatar.tsx + 2 modules
var Avatar = __webpack_require__(89646);
// EXTERNAL MODULE: ./utilities/createBucketUrl.ts
var createBucketUrl = __webpack_require__(37785);
// EXTERNAL MODULE: ./utilities/functions.ts + 5 modules
var functions = __webpack_require__(12477);
// EXTERNAL MODULE: ./components/cards/AvatarInfo.tsx
var AvatarInfo = __webpack_require__(10934);
;// CONCATENATED MODULE: ./components/cards/CollectionInfoCard.tsx






var CollectionInfoCard = function(param) {
    var collection = param.collection, count = param.count, _classes = param.classes, classes = _classes === void 0 ? "" : _classes;
    var ref, ref1;
    var cleanedAddress = (0,functions/* cleanAddress */.Wm)(collection.nft_contract_address);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-span-1 ".concat(classes),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarInfo/* default */.Z, {
            size: Avatar/* AvatarSize.sm */.DZ.sm,
            shape: Avatar/* AvatarShape.square */.oG.square,
            image: (0,createBucketUrl/* createBucketURL */.C)(createBucketUrl/* BucketType.Collection */.a.Collection, cleanedAddress),
            count: count,
            alt: (ref2 = collection === null || collection === void 0 ? void 0 : collection.name) !== null && ref2 !== void 0 ? ref2 : "",
            title: collection ? "".concat(collection === null || collection === void 0 ? void 0 : (ref = collection.name) === null || ref === void 0 ? void 0 : ref.charAt(0).toUpperCase()).concat(collection === null || collection === void 0 ? void 0 : (ref1 = collection.name) === null || ref1 === void 0 ? void 0 : ref1.slice(1)) : ""
        })
    });
};
/* harmony default export */ var cards_CollectionInfoCard = (CollectionInfoCard);

// EXTERNAL MODULE: ./components/display/BudgetPerAsset.tsx + 2 modules
var BudgetPerAsset = __webpack_require__(98781);
// EXTERNAL MODULE: ./components/formatting/TitleWithChildren.tsx
var TitleWithChildren = __webpack_require__(21549);
// EXTERNAL MODULE: ./constants/constants.ts
var constants = __webpack_require__(36630);
// EXTERNAL MODULE: ./hooks/useDelegatedNfts.ts + 2 modules
var useDelegatedNfts = __webpack_require__(56668);
// EXTERNAL MODULE: ./hooks/useNftsOwned.ts
var useNftsOwned = __webpack_require__(21298);
// EXTERNAL MODULE: ./hooks/usePageEntrance.ts
var usePageEntrance = __webpack_require__(7414);
// EXTERNAL MODULE: ./store/toastSlice.ts
var toastSlice = __webpack_require__(8645);
// EXTERNAL MODULE: ./utilities/dateFormatter.ts
var dateFormatter = __webpack_require__(17695);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/validator/index.js
var validator = __webpack_require__(86468);
var validator_default = /*#__PURE__*/__webpack_require__.n(validator);
// EXTERNAL MODULE: ../../node_modules/xss/lib/index.js
var lib = __webpack_require__(223);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./utilities/currencyConvert.ts
var currencyConvert = __webpack_require__(63187);
;// CONCATENATED MODULE: ./utilities/sanitization.ts







// TODO: If you're working with storing images that are sent through the requests, you'll want to use this function to sanitize the images before storing them in the database.
function isValidUrlForHost(url, host) {
    var options = {
        protocols: [
            "http",
            "https"
        ],
        host_whitelist: [
            host
        ]
    };
    return validator_default().isURL(url, options);
}
var sanitizeAndReplaceMarkup = function(content, searchValue, replaceValue) {
    var replacedContent = content.replace(searchValue, replaceValue);
    var sanitizedContent = lib_default()(replacedContent, {
        whiteList: {
            span: [
                "class"
            ],
            br: [
                ""
            ],
            img: [
                "src",
                "alt",
                "class"
            ],
            a: [
                "href",
                "target",
                "class"
            ]
        }
    });
    return {
        __html: sanitizedContent
    };
};
var sanitizeAndValidateParameters = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", Promise.all(params.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                            var value, type, address, currency, numberValue, numberValue1;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        value = param.value, type = param.type;
                                        if (!(value === undefined && !(type === "text?" || type === "facebook?" || type === "instagram?" || type === "opensea?" || type === "twitter?" || type === "number?"))) {
                                            _ctx.next = 3;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.MISSING_PARAMETER */.O1.MISSING_PARAMETER);
                                    case 3:
                                        _ctx.t0 = type;
                                        _ctx.next = _ctx.t0 === "address" ? 6 : _ctx.t0 === "currency" ? 10 : _ctx.t0 === "signature" ? 14 : _ctx.t0 === "text" ? 17 : _ctx.t0 === "text?" ? 18 : _ctx.t0 === "number" ? 23 : _ctx.t0 === "number?" ? 27 : _ctx.t0 === "facebook?" ? 35 : _ctx.t0 === "instagram?" ? 38 : _ctx.t0 === "opensea?" ? 41 : _ctx.t0 === "twitter?" ? 44 : 47;
                                        break;
                                    case 6:
                                        address = (0,functions/* cleanAddress */.Wm)(value);
                                        if (validator_default().isEthereumAddress(String(address))) {
                                            _ctx.next = 9;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_ADDRESS */.O1.INVALID_ADDRESS);
                                    case 9:
                                        return _ctx.abrupt("return", address);
                                    case 10:
                                        currency = currencyConvert/* Erc20DecimalEnum */.W5[value];
                                        if (currency) {
                                            _ctx.next = 13;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_PAYMENT_CURRENCY */.O1.INVALID_PAYMENT_CURRENCY);
                                    case 13:
                                        return _ctx.abrupt("return", validator_default().escape(value));
                                    case 14:
                                        if (!(!validator_default().isAlphanumeric(value) || value.length !== 132)) {
                                            _ctx.next = 16;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_SIGNATURE */.O1.INVALID_SIGNATURE);
                                    case 16:
                                        return _ctx.abrupt("return", validator_default().escape(value));
                                    case 17:
                                        return _ctx.abrupt("return", validator_default().escape(value));
                                    case 18:
                                        if (!value) {
                                            _ctx.next = 22;
                                            break;
                                        }
                                        return _ctx.abrupt("return", validator_default().escape(value));
                                    case 22:
                                        return _ctx.abrupt("return", null);
                                    case 23:
                                        numberValue = parseInt(value, 10);
                                        if (!isNaN(numberValue)) {
                                            _ctx.next = 26;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_NUMBER */.O1.INVALID_NUMBER);
                                    case 26:
                                        return _ctx.abrupt("return", numberValue);
                                    case 27:
                                        if (!value) {
                                            _ctx.next = 34;
                                            break;
                                        }
                                        numberValue1 = parseInt(value, 10);
                                        if (!isNaN(numberValue1)) {
                                            _ctx.next = 31;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_NUMBER */.O1.INVALID_NUMBER);
                                    case 31:
                                        return _ctx.abrupt("return", numberValue1);
                                    case 34:
                                        return _ctx.abrupt("return", null);
                                    case 35:
                                        if (!(value && !isValidUrlForHost(value, "facebook.com"))) {
                                            _ctx.next = 37;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_FACEBOOK_ADDRESS */.O1.INVALID_FACEBOOK_ADDRESS);
                                    case 37:
                                        return _ctx.abrupt("return", value ? value : null);
                                    case 38:
                                        if (!(value && !isValidUrlForHost(value, "instagram.com"))) {
                                            _ctx.next = 40;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_INSTAGRAM_ADDRESS */.O1.INVALID_INSTAGRAM_ADDRESS);
                                    case 40:
                                        return _ctx.abrupt("return", value ? value : null);
                                    case 41:
                                        if (!(value && !isValidUrlForHost(value, "opensea.io"))) {
                                            _ctx.next = 43;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_OPENSEA_ADDRESS */.O1.INVALID_OPENSEA_ADDRESS);
                                    case 43:
                                        return _ctx.abrupt("return", value ? value : null);
                                    case 44:
                                        if (!(value && !isValidUrlForHost(value, "twitter.com"))) {
                                            _ctx.next = 46;
                                            break;
                                        }
                                        throw new Error(constants/* ERROR_CODES.INVALID_TWITTER_ADDRESS */.O1.INVALID_TWITTER_ADDRESS);
                                    case 46:
                                        return _ctx.abrupt("return", value ? value : null);
                                    case 47:
                                        throw new Error(constants/* ERROR_CODES.UNSUPPORTED_DATA_TYPE */.O1.UNSUPPORTED_DATA_TYPE);
                                    case 48:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(param) {
                            return _ref.apply(this, arguments);
                        };
                    }())));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sanitizeAndValidateParameters(params) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/sections/DealComponent.tsx




























var DealComponent = function(param) {
    var deal = param.deal, requestedNumberOfNfts = param.requestedNumberOfNfts, _isCreatingDeal = param.isCreatingDeal, isCreatingDeal = _isCreatingDeal === void 0 ? false : _isCreatingDeal, _hasCollectionLinks = param.hasCollectionLinks, hasCollectionLinks = _hasCollectionLinks === void 0 ? true : _hasCollectionLinks;
    var ref;
    (0,usePageEntrance/* usePageEntrance */.s)();
    var address = (0,dist/* useAccount */.mA)().address;
    var status = (0,react.useSession)().status;
    var router = (0,next_router.useRouter)();
    var nfts = (0,useNftsOwned/* default */.Z)(address).nfts;
    var delegatedNfts = (0,useDelegatedNfts/* default */.Z)(address).delegatedNfts;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ownedCollections = (0,_to_consumable_array/* default */.Z)(nfts).concat((0,_to_consumable_array/* default */.Z)(delegatedNfts)).map(function(collection) {
        return (0,functions/* cleanAddress */.Wm)(collection.address);
    });
    var ownedCollectionsInDeal = deal.CollectionDeals.filter(function(param) {
        var Collection = param.Collection;
        return ownedCollections.includes((0,functions/* cleanAddress */.Wm)(Collection.nft_contract_address));
    });
    var isBiddingSubmissionExpired = moment_timezone_with_data_2012_2022_default()(deal.bidding_expiration).isBefore(moment_timezone_with_data_2012_2022_default()());
    var canMakeProposal = ownedCollectionsInDeal.length > 0 && !isBiddingSubmissionExpired;
    var isDealCreator = deal.wallet_address === address && status === "authenticated";
    var localLicenseExpirationDate = (0,dateFormatter/* getLocalDate */.ZF)(deal.license_expiration, constants/* DATE_FORMATS.MMMDYhm */.lv.MMMDYhm);
    var localSubmissionExpirationDate = (0,dateFormatter/* getLocalDate */.ZF)(deal.bidding_expiration, constants/* DATE_FORMATS.MMMDYhm */.lv.MMMDYhm);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,dateFormatter/* getHumanizedDate */.n$)(localSubmissionExpirationDate), 2), humanizedLocalSubmissionExpirationDate = ref1[0], dateEnum = ref1[1];
    var _dateEnum = dateFormatter/* DateThemeMap */.xj[dateEnum], theme = _dateEnum.theme, pulse = _dateEnum.pulse, dot = _dateEnum.dot;
    var _username, ref2, _bonus_config, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-start md:space-y-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "enter-el-inherit text-neutral-50",
                            children: !!deal.id && (isDealCreator || !canMakeProposal) ? "View Proposals" : isCreatingDeal ? "Publish Opportunity" : "Submit Proposal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "enter-el-inherit pb-5 font-gt-haptik text-heading-4-mobile font-bold text-neutral-100 md:text-heading-4",
                            children: "Review Opportunity"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "enter-el-inherit flex flex-col items-start justify-between space-y-3 md:flex-row md:items-center md:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col items-start space-y-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center space-x-4 md:flex-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.ZP, {
                                                size: Avatar/* AvatarSize.md */.DZ.md,
                                                link: "/brand/".concat(encodeURI((_username = deal.Brand.username) !== null && _username !== void 0 ? _username : "")),
                                                src: (0,createBucketUrl/* createBucketURL */.C)(createBucketUrl/* BucketType.Brand */.a.Brand, deal.Brand.username, deal.Brand.updated_at)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-neutral-100",
                                                        children: deal.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-neutral-50",
                                                        children: [
                                                            deal.Brand.company_name,
                                                            deal.Brand.legal_name ? " / ".concat(deal.Brand.legal_name) : ""
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                !!deal.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full items-center justify-start md:ml-auto md:w-auto md:justify-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                        size: Button/* ButtonSize.primary */.qE.primary,
                                        type: !canMakeProposal && !isDealCreator ? Button/* ButtonType.disabled */.L$.disabled : Button/* ButtonType.primary */.L$.primary,
                                        onClick: function() {
                                            if (canMakeProposal || isDealCreator) {
                                                void router.push({
                                                    pathname: "/deal/".concat(deal.id, "/").concat(isDealCreator ? "bids" : "submitBid", "/")
                                                });
                                            } else {
                                                dispatch((0,toastSlice/* addToast */.fz)({
                                                    title: "No eligible collections found. Please connect with a valid wallet.",
                                                    type: Toast/* ToastType.warning */.pC.warning
                                                }));
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "flex items-center justify-center",
                                            children: [
                                                isDealCreator ? "View Proposals" : "Submit Proposal",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pl-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiRightArrowAlt */.OEZ, {})
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "enter-el-inherit w-full py-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-6 text-neutral-50",
                            children: "Eligible Collections"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-x-2 gap-y-6 md:grid-cols-2 md:space-y-0 lg:grid-cols-3",
                            children: deal.CollectionDeals.map(function(param) {
                                var Collection = param.Collection, count = param.count;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: hasCollectionLinks ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/collection/".concat((0,functions/* cleanAddress */.Wm)(Collection.nft_contract_address)),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-1 cursor-pointer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_CollectionInfoCard, {
                                                collection: Collection,
                                                count: count
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_CollectionInfoCard, {
                                        collection: Collection,
                                        count: count
                                    })
                                }, Collection.name);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "enter-el-inherit grid w-full grid-cols-1 gap-x-2 gap-y-6 py-6 md:grid-cols-2 ".concat(isCreatingDeal ? "" : "lg:grid-cols-3"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWithChildren/* TitleWithChildren */.U, {
                            title: "Submission Deadline",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.ZP, {
                                theme: theme,
                                classes: "my-0",
                                pulse: pulse,
                                showDot: dot,
                                title: localSubmissionExpirationDate,
                                children: humanizedLocalSubmissionExpirationDate
                            })
                        }),
                        !isCreatingDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWithChildren/* TitleWithChildren */.U, {
                            title: "Number of Assets Submitted",
                            children: String((ref2 = (ref = deal.Bids_aggregate.aggregate) === null || ref === void 0 ? void 0 : ref.count) !== null && ref2 !== void 0 ? ref2 : 0)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWithChildren/* TitleWithChildren */.U, {
                            title: "License Expiration",
                            children: localLicenseExpirationDate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetPerAsset/* BudgetPerAsset */.E, {
                            paymentCurrency: deal.payment_currency,
                            minBudget: deal.min_budget,
                            maxBudget: deal.max_budget,
                            royaltyPercentage: deal.royalty_percentage,
                            isCreatingDeal: isCreatingDeal,
                            collectionAddress: deal.CollectionDeals[0].Collection.nft_contract_address,
                            publishedDate: deal.created_at,
                            bonusConfig: (_bonus_config = deal.bonus_config) !== null && _bonus_config !== void 0 ? _bonus_config : undefined
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWithChildren/* TitleWithChildren */.U, {
                            title: "Requested Number of Assets",
                            children: requestedNumberOfNfts
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "enter-el-inherit flex w-full flex-col pt-6 text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "pb-2 text-left text-neutral-50",
                            children: "Summary"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "hidden font-satoshi-italic"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "justify-self-end pb-2 font-regular text-black sm:pb-0",
                            dangerouslySetInnerHTML: sanitizeAndReplaceMarkup((_description = deal.description) !== null && _description !== void 0 ? _description : "", /\n/g, "<br>")
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 7414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ usePageEntrance; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74682);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31470);
/* harmony import */ var _app_config_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_config_js__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable */ 


var usePageEntrance = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), once = ref[0], setOnce = ref[1];
    var onceVar = false;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (once || onceVar) {
            return;
        }
        setOnce(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        onceVar = true;
        // @ts-ignore
        var timeline = new gsap__WEBPACK_IMPORTED_MODULE_2__/* .gsap.timeline */ .p8.timeline();
        var int = setInterval(function() {
            if ((_app_config_js__WEBPACK_IMPORTED_MODULE_1___default().transitionFinished)) {
                clearInterval(int);
                var enterEls = document.querySelectorAll(".enter-el, .enter-el-block, .enter-el-inherit");
                timeline.fromTo(enterEls, {
                    y: 40
                }, {
                    y: 0,
                    stagger: .07,
                    force3D: true,
                    duration: 1.4,
                    ease: "expo.out"
                }).fromTo(enterEls, {
                    opacity: 0
                }, {
                    opacity: 1,
                    stagger: .07,
                    force3D: true,
                    duration: 1.35,
                    ease: "expo.out"
                }, 0.05);
            }
        });
    });
};


/***/ })

}]);